import React from 'react';
import { Field, FieldProps } from 'formik';

import { Input } from '../inputs';
import { Props as InputProps } from '../inputs/Input';

const CustomField = ({ field, form, ...props }: FieldProps<InputProps>) => <Input {...field} {...props} />;

const FormInput = (props: Partial<InputProps>) => <Field {...props} component={CustomField} />;

export default FormInput;
